// extracted by mini-css-extract-plugin
export var gif = "_eo-0";